<template>
  <div class="saved-items-page">
    <div class="text-h4 q-mb-md text-left tab-heading-color test">
      Opgeslagen items
    </div>
    <q-splitter
      v-model="splitterModel"
      style="min-height: calc(100vh - 310px)"
      class="saved-items-small"
    >
      <template v-slot:before class="savedItemsTab">
        <div style="min-height: 15vh;" class="new-folder-container">
          <q-btn no-caps @click="enableAddNew()" class="q-mb-md newFolder">
            <i class="las la-2x la-folder-plus"></i>
            <span style="font-weight: bold">&nbsp;&nbsp;&nbsp;Nieuwe map</span>
          </q-btn>
          <div class="folders-list">
            <!--    <q-scroll-area
              :bar-style="barStyle"
              :thumb-style="thumbStyle"
              visible
              class="tree-scroll-area"
            > -->
            <div
              class="q-pa-sm q-gutter-sm text-left folders-btns"
              v-for="folder in foldersWithItems"
              :key="folder.id"
            >
              <div>
                <a
                  class="selected-folder"
                  v-if="folder.id == selectedFolderId"
                  @click="getItems(folder.id)"
                >
                  <i class="las la-2x la-folder-open"></i>
                  {{ folder.name }}
                </a>
                <a
                  v-else
                  class="non-selected-folder"
                  @click="getItems(folder.id)"
                >
                  <i class="las la-2x la-folder"></i>
                  {{ folder.name }}
                </a>
                <div class="float-right">
                  <i
                    class="las la-2x la-edit la-fw action-icon"
                    style="grey-9"
                    @click="enableRenameFolder(folder.id, folder.name)"
                  >
                    <q-tooltip> Map hernoemen </q-tooltip>
                  </i>
                  <i
                    class="las la-2x la-trash la-fw action-icon"
                    color="grey-9"
                    @click="
                      (confirmDeleteFolder = true), (pickedFolderId = folder.id)
                    "
                  >
                    <q-tooltip> Map verwijderen </q-tooltip>
                  </i>
                </div>
              </div>
            </div>
            <!--             </q-scroll-area>
 -->
          </div>
        </div>
      </template>
      <template v-slot:after>
        <q-card v-if="selectedFolderId != null">
          <q-tabs
            v-model="savedItemsTab"
            dense
            class="text-grey"
            align="justify"
            narrow-indicator
          >
            <q-tab name="schemes" label="Opgeslagen items"> </q-tab>
            <q-tab name="searches" label="Opgeslagen zoekacties"> </q-tab>
          </q-tabs>

          <q-separator />

          <q-tab-panels v-model="savedItemsTab" animated swipeable>
            <q-tab-panel name="schemes">
              <div
                id="q-app"
                style="min-height: 100vh;"
                v-if="folderSchemesItems.length > 0"
              >
                <div class="q-pa-md">
                  <q-table
                    :rows="folderSchemesItems"
                    :columns="savedSchemesColumns"
                    row-key="id"
                    :filter="filterSchemes"
                    :filter-method="schemesFilter"
                    :rows-per-page-label="'Resultaten per pagina'"
                  >
                    <template v-slot:top>
                      <q-input
                        borderless
                        dense
                        debounce="300"
                        color="primary"
                        placeholder="Zoek"
                        v-model="filterSchemes"
                      >
                        <template v-slot:append>
                          <q-icon name="search" />
                        </template>
                      </q-input>
                      <q-space />
                      <i
                        v-if="selectedFolderId != 0"
                        class="las la-2x la-download action-icon"
                        style="color: #0a108f"
                        @click="generateFolderReport()"
                      >
                        <q-tooltip> Genereer rapport </q-tooltip></i
                      >
                    </template>

                    <template v-slot:body="props">
                      <q-tr :props="props">
                        <!-- <q-td key="name" :props="props">{{ props.row.scheme != null ? props.row.scheme.name : null }}</q-td> -->
                        <q-td
                          key="name"
                          v-if="props.row.scheme != null"
                          class="scheme-name-link"
                        >
                          <router-link
                            style="text-decoration: none"
                            :to="{
                              name: 'GrantDetails',
                              params: { grantId: props.row.schemeId },
                            }"
                          >
                            {{
                              props.row.scheme != null
                                ? props.row.scheme.name
                                : null
                            }}
                          </router-link>
                        </q-td>

                        <!--      <q-td key="identifier" :props="props">{{
                          props.row.scheme != null
                            ? props.row.scheme.identifier
                            : null
                        }}</q-td> -->
                        <q-td key="status" :props="props">{{
                          props.row.scheme != null
                            ? props.row.scheme.status
                            : null
                        }}</q-td>
                        <q-td key="alert" :props="props" class="q-gutter-xs">
                          <i
                            v-if="props.row.hasAlert == false"
                            class="las la-2x la-toggle-off"
                            style="color:#0A108F"
                            @click="
                              updateAlert(
                                props.row.id,
                                props.row.folderId,
                                true
                              )
                            "
                          >
                            <q-tooltip>
                              Alert aanzetten
                            </q-tooltip>
                          </i>
                          <i
                            v-if="props.row.hasAlert == true"
                            class="las la-2x la-toggle-on alert-color"
                            @click="
                              updateAlert(
                                props.row.id,
                                props.row.folderId,
                                false
                              )
                            "
                          >
                            <q-tooltip>
                              Alert aanzetten
                            </q-tooltip>
                          </i>
                        </q-td>
                        <q-td key="actions" :props="props" class="q-gutter-xs">
                          <q-btn
                            v-if="props.row.scheme != null"
                            class="details-btn"
                            size="sm"
                            no-caps
                            :to="{
                              name: 'GrantDetails',
                              params: { grantId: props.row.schemeId },
                            }"
                          >
                            <i class="las la-2x la-eye"></i>
                            <q-tooltip>
                              Details
                            </q-tooltip>
                          </q-btn>
                          <q-btn
                            v-if="props.row.scheme != null"
                            color="grey-9"
                            @click="
                              (confirmSchemeDelete = true),
                                (schemeItemId = props.row.id),
                                (folderId = props.row.folderId)
                            "
                            size="sm"
                            no-caps
                          >
                            <i class="las la-2x la-ban la-trash"></i>
                            <q-tooltip>
                              Verwijderen
                            </q-tooltip>
                          </q-btn>
                        </q-td>
                      </q-tr>
                    </template>
                  </q-table>
                </div>
              </div>
              <div v-else>Er zijn nog geen opgeslagen items</div>
            </q-tab-panel>

            <q-tab-panel name="searches">
              <div
                id="q-app"
                style="min-height: 100vh;"
                v-if="folderSearchesItems.length > 0"
              >
                <div class="q-pa-md">
                  <q-table
                    :rows="folderSearchesItems"
                    :columns="savedSearchesColumns"
                    row-key="id"
                    :filter="filter"
                    :loading="loading"
                    :filter-method="searchesFilter"
                    :pagination="initialPagination"
                    :rows-per-page-label="'Resultaten per pagina'"
                  >
                    <template v-slot:top>
                      <q-input
                        borderless
                        dense
                        debounce="300"
                        color="primary"
                        placeholder="Zoek"
                        v-model="filter"
                      >
                        <template v-slot:append>
                          <q-icon name="search" />
                        </template>
                      </q-input>
                    </template>

                    <template v-slot:body="props">
                      <q-tr :props="props">
                        <q-td key="title" :props="props">
                          <a
                            @click="applyFilter(props.row.searchId)"
                            class="saved-search-title"
                          >
                            {{
                              props.row.savedSearch != null
                                ? props.row.savedSearch.title
                                : null
                            }}
                          </a>
                        </q-td>
                        <q-td key="alert" :props="props" class="q-gutter-xs">
                          <i
                            v-if="props.row.hasAlert == false"
                            class="las la-2x la-toggle-off"
                            style="color:#0A108F"
                            @click="
                              updateAlert(
                                props.row.id,
                                props.row.folderId,
                                true
                              )
                            "
                          >
                            <q-tooltip>
                              Alert aanzetten
                            </q-tooltip>
                          </i>
                          <i
                            v-if="props.row.hasAlert == true"
                            class="las la-2x la-toggle-on alert-color"
                            @click="
                              updateAlert(
                                props.row.id,
                                props.row.folderId,
                                false
                              )
                            "
                          >
                            <q-tooltip>
                              Alert uitzetten
                            </q-tooltip>
                          </i>
                        </q-td>
                        <q-td
                          key="applyFilters"
                          :props="props"
                          class="text-right q-gutter-xs"
                        >
                          <q-btn
                            v-if="props.row.savedSearch != null"
                            class="details-btn"
                            size="sm"
                            no-caps
                            @click="applyFilter(props.row.searchId)"
                          >
                            <i class="las la-2x la-search"></i>
                            <q-tooltip>
                              Filter toepassen
                            </q-tooltip>
                          </q-btn>
                          <q-btn
                            v-if="props.row.savedSearch != null"
                            color="grey-9"
                            @click="
                              (confirm = true),
                                (searchId = props.row.searchId),
                                (folderId = props.row.folderId)
                            "
                            size="sm"
                            no-caps
                          >
                            <i class="las la-2x la-ban la-trash"></i>
                            <q-tooltip>
                              Verwijderen
                            </q-tooltip>
                          </q-btn>
                        </q-td>
                      </q-tr>
                    </template>
                  </q-table>
                </div>
              </div>
              <div v-else>Er zijn nog geen opgeslagen zoekopdrachten</div>
            </q-tab-panel>
          </q-tab-panels>
        </q-card>
        <q-dialog
          v-model="showRenameFolderDialog"
          persistent
          class="rename-folder-dialog"
        >
          <q-card style="min-width: 350px">
            <q-card-section>
              <div style="color: #0a108f">
                <i class="las la-2x la-pen la-fw"></i>
                Map hernoemen
              </div>
            </q-card-section>
            <q-separator />
            <q-card-section class="q-pt-none">
              <div class="row">
                <q-input
                  class="q-pa-md"
                  style="min-width: 300px;"
                  v-model="pickedFolderName"
                  autogrow
                  :placeholder="pickedFolderName"
                  :rules="requiredFieldRule"
                >
                </q-input>
              </div>
            </q-card-section>
            <q-card-actions align="right">
              <q-btn
                style="background: #0a108f; color: white"
                no-caps
                flat
                label="Opslaan"
                @click="renameFolder(pickedFolderId, pickedFolderName)"
              />
              <q-btn
                flat
                style="color: #0a108f; border: 1px solid gray; border-radius: 5px;"
                outline
                no-caps
                label="Annuleren"
                @click="disableRenameFolder()"
              />
            </q-card-actions>
          </q-card>
        </q-dialog>
        <q-dialog v-model="confirm" persistent>
          <q-card>
            <q-card-section class="row items-center">
              <i class="las la-2x la-trash la-fw"></i>
              <span class="q-ml-sm"
                >Do yo want to remove this this saved-search?</span
              >
            </q-card-section>
            <q-card-actions align="right">
              <q-btn
                label="Verwijderen"
                no-caps
                color="white"
                class="submit-btn-profile"
                flat
                v-close-popup
                @click="removeSavedSearch(searchId, folderId)"
              />
              <q-btn
                outline
                label="Annuleren"
                v-close-popup
                no-caps
                flat
                class="cancel-btn-searches"
              />
            </q-card-actions>
          </q-card>
        </q-dialog>
        <q-dialog v-model="confirmSchemeDelete" persistent>
          <q-card>
            <q-card-section class="row items-center">
              <i class="las la-2x la-trash la-fw"></i>
              <span class="q-ml-sm"
                >Weet u zeker dat u deze regeling wilt verwijderen uit je
                opgeslagen items?
              </span>
            </q-card-section>

            <q-card-actions align="right">
              <q-btn
                label="Verwijderen"
                flat
                no-caps
                color="white"
                class="submit-btn-profile"
                v-close-popup
                @click="removeSavedScheme(schemeItemId, folderId)"
              />
              <q-btn
                outline
                label="Annuleren"
                class="cancel-btn-searches"
                v-close-popup
                flat
                no-caps
              />
            </q-card-actions>
          </q-card>
        </q-dialog>
        <q-dialog v-model="confirmDeleteFolder" persistent>
          <q-card>
            <q-card-section class="row items-center">
              <i class="las la-2x la-trash la-fw"></i>
              <span class="q-ml-sm">
                Weet je zeker dat je deze map wilt verwijderen?</span
              >
            </q-card-section>

            <q-card-actions align="right">
              <q-btn
                style="background: #0a108f; color: white"
                label="Verwijderen"
                no-caps
                v-close-popup
                @click="removeFolder(pickedFolderId)"
              />
              <q-btn
                style="color: #0a108f; border: 1px solid gray; border-radius: 5px;"
                no-caps
                label="Annuleren"
                flat
                v-close-popup
              />
            </q-card-actions>
          </q-card>
        </q-dialog>
        <q-dialog v-model="showAddNew" persistent>
          <q-card style="min-width: 350px">
            <q-card-section>
              <div style="color: #0a108f">Maak een nieuwe map</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <div class="row justify-around">
                <q-input
                  dense
                  v-model="newFolderName"
                  outlined
                  stack-label
                  placeholder="Vul een mapnaam in"
                  :rules="requiredFieldRule"
                  style="width: 100%"
                />
              </div>
            </q-card-section>
            <q-separator />
            <q-card-actions align="around" class="new-profile-actions">
              <q-btn
                label="Opslaan"
                @click="addNewFolder()"
                class="submit-btn-profile"
                no-caps
                color="white"
                flat
              />
              <q-btn
                outline
                flat
                class="cancel-btn-searches"
                label="Annuleer"
                no-caps
                @click="disableAddNew()"
              />
            </q-card-actions>
          </q-card>
        </q-dialog>
      </template>
    </q-splitter>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import store from '../../store/index.js';
import UserService from '../../services/userprofile.service';
import GrantsService from '../../services/grants.service.js';
import SchemeUtils from '../../utils/schemes';
import authHeader from '../../helpers/auth-header';

export default {
  name: 'SavedItems',
  setup() {
    const savedSchemesColumns = [
      {
        name: 'name',
        align: 'left',
        label: 'Naam',
        field: 'name',
        sortable: true,
        class: 'table-heading',
      },
      /*      {
        name: 'identifier',
        align: 'left',
        label: 'Identifier',
        field: 'identifier',
        sortable: true,
      }, */
      {
        name: 'status',
        align: 'left',
        label: 'Status',
        field: 'status',
        sortable: true,
        class: 'table-heading',
      },
      { name: 'alert', label: 'Alert', align: 'center' },
      { name: 'actions', align: 'center' },
    ];

    const savedSearchesColumns = [
      {
        name: 'title',
        align: 'left',
        label: 'Naam',
        field: 'title',
        sortable: true,
      },
      {
        name: 'alert',
        label: 'Alert',
        align: 'center',
      },
      // { name: 'description', align: 'left', label: 'Description', field: 'description', sortable: true },
      { name: 'applyFilters', align: 'center' },
    ];

    const savedItemsTab = ref('schemes');
    const filterSchemes = ref('');
    const filter = ref('');
    const loading = ref(false);
    const confirm = ref(false);
    const confirmSchemeDelete = ref(false);
    const confirmDeleteFolder = ref(false);
    const searchId = ref(null);
    const schemeItemId = ref(null);
    const foldersWithItems = computed({
      get: () => store.state.user.foldersList,
    });

    const folderId = ref(null);
    const selectedFolderId = ref(null);

    var newFolderName = ref('');

    const firstFolderId = computed({
      get: () => store.state.user.firstFolderId,
    });

    onMounted(async () => {
      await UserService.getFoldersWithItems();
      getItems(firstFolderId.value);
    });

    const folderSchemesItems = computed({
      get: () => store.state.user.folderSchemes,
    });
    const folderSearchesItems = computed({
      get: () => store.state.user.folderSearches,
    });

    const getItems = (folderId) => {
      selectedFolderId.value = folderId;
      UserService.getFolderItems(folderId);
    };

    const applyFilter = async (searchId) => {
      // reset all filters
      store.commit('advancedSearch/updateapplySavedSearchPause', true);
      UserService.loadFilter(searchId);
      UserService.setApplyFilter(false);
      await SchemeUtils.searchSchemes();
      store.commit('advancedSearch/updateapplySavedSearchPause', false);
    };

    const removeSavedScheme = async (schemeItemId, folderId) => {
      await UserService.removeSavedScheme(schemeItemId);
      await UserService.getFolderItems(folderId);
    };

    const removeSavedSearch = async (searchId, folderId) => {
      await GrantsService.removeSavedSearch(searchId, folderId);
      await UserService.getFolderItems(folderId);
    };

    const updateAlert = async (itemId, folderId, value) => {
      await UserService.updateFolderItemAlert(itemId, value);
      await UserService.getFolderItems(folderId);
    };

    const updateAlertSearch = async () => {
      console.log('search update alert');
    };

    const enableAddNew = () => {
      store.commit('user/enableAddNew');
    };

    const showAddNew = computed({
      get: () => store.state.user.showAddNew,
    });

    const addNewFolder = async () => {
      await UserService.addNewFolder(newFolderName.value);
      store.commit('user/disableAddNew');
      UserService.getFoldersWithItems();
      newFolderName.value = '';
    };

    const disableAddNew = () => {
      store.commit('user/disableAddNew');
      newFolderName.value = '';
    };
    const initialPagination = {
      sortBy: 'desc',
      descending: false,
      page: 1,
      rowsPerPage: 10,
      // rowsNumber: xx if getting data from a server
    };

    const foldersLength = computed({
      get: () => store.state.user.foldersList.length,
    });

    const generateFolderReport = async () => {
      let form = document.createElement('form');
      form.method = 'post';
      form.target = '_blank';
      form.action = `../api/download/generateFolderReport?folderId=${selectedFolderId.value}`;
      form.innerHTML = `'<input type="hidden" name="jwtToken" value="${
        authHeader().Authorization
      }">'`;
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    };

    // the name of the folder to be modified
    const pickedFolderName = computed({
      get: () => store.state.user.pickedFolderName,
      set: (value) => store.commit('user/updatePickedFolderName', value),
    });

    //the id of the folder to be modified
    const pickedFolderId = ref(null);

    const showRenameFolderDialog = computed({
      get: () => store.state.user.showRenameFolderDialog,
    });

    const enableRenameFolder = (folderId, folderName) => {
      pickedFolderId.value = folderId;
      store.commit('user/enableRenameFolderDialog', folderName);
    };

    const disableRenameFolder = () => {
      store.commit('user/disableRenameFolderDialog');
    };

    const renameFolder = async () => {
      await UserService.renameFolder(pickedFolderName, pickedFolderId);
      store.commit('user/disableRenameFolderDialog');
      UserService.getFoldersWithItems();
    };

    const removeFolder = async (folderId) => {
      await UserService.removeFolder(folderId);
      UserService.getFoldersWithItems();
    };

    return {
      removeFolder,
      confirmDeleteFolder,
      renameFolder,
      disableRenameFolder,
      showRenameFolderDialog,
      pickedFolderId,
      pickedFolderName,
      enableRenameFolder,
      firstFolderId,
      foldersLength,
      initialPagination,
      splitterModel: ref(15),
      savedItemsTab,
      savedSchemesColumns,
      savedSearchesColumns,
      foldersWithItems,
      searchId,
      folderId,
      getItems,
      folderSchemesItems,
      folderSearchesItems,
      filterSchemes,
      filter,
      loading,
      confirm,
      applyFilter,
      removeSavedSearch,
      selectedFolderId,
      confirmSchemeDelete,
      removeSavedScheme,
      schemeItemId,
      updateAlert,
      updateAlertSearch,
      enableAddNew,
      showAddNew,
      newFolderName,
      disableAddNew,
      addNewFolder,
      generateFolderReport,
      barStyle: {
        right: '2px',
        borderRadius: '9px',
        backgroundColor: '#f0f2f5',
        width: '8px',
        opacity: 0.2,
      },
      thumbStyle: {
        right: '4px',
        borderRadius: '7px',
        /*         backgroundColor: '#0a108f',
         */

        width: '4px',
        opacity: 0.75,
      },

      requiredFieldRule: [
        (val) => (val && val.length > 0) || 'Veld is verplicht!',
      ],
      schemesFilter(rows, terms) {
        // rows contain the entire data
        // terms contains whatever you have as filter
        const lowerFilter = terms ? terms.toLowerCase() : '';
        if (lowerFilter != '') {
          return rows.filter(
            (row) => row.scheme.name.toLowerCase().indexOf(lowerFilter) > -1
          );
        } else {
          return rows;
        }
      },
      searchesFilter(rows, terms) {
        // rows contain the entire data
        // terms contains whatever you have as filter
        const lowerFilter = terms ? terms.toLowerCase() : '';
        if (lowerFilter != '') {
          return rows.filter(
            (row) =>
              row.savedSearch.title.toLowerCase().indexOf(lowerFilter) > -1
          );
        } else {
          return rows;
        }
      },
    };
  },
};
</script>
